import { render, staticRenderFns } from "./Retag.vue?vue&type=template&id=3bac87ad"
import script from "./Retag.vue?vue&type=script&lang=ts"
export * from "./Retag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports